/** MedClip extension app id and project names (MEDCLIP_GUIDE.md). */
export const MEDCLIP_APP_ID = "medclip";

export const MEDCLIP_PROJECT_PROD = "report-engine";
export const MEDCLIP_PROJECT_LOCAL = "report-engine-local";

export const MEDCLIP_LAST_COMPLETED_TTL_MS = 5 * 60 * 1000;
export const MEDCLIP_CANCELED_STUDY_TTL_MS = 5 * 60 * 1000;

export function isMedClipIntegrationDisabledRoute() {
  if (typeof window === "undefined") return false;
  return window.location.pathname.startsWith("/videos/");
}

export function getMedClipProjectName() {
  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1"
    ? MEDCLIP_PROJECT_LOCAL
    : MEDCLIP_PROJECT_PROD;
}

export function isMedClipProjectAllowed(projectName) {
  if (!projectName) return false;
  if (projectName === MEDCLIP_PROJECT_PROD) return true;
  if (String(projectName).endsWith("-local")) return true;
  return false;
}

/**
 * Accept MedClip messages; reject explicit other apps (e.g. zikaron).
 * Absent source is treated as legacy-compatible.
 */
function isMedClipSourceCompatible(source) {
  if (!source) return true;
  if (source === MEDCLIP_APP_ID) return true;
  if (source === "zikaron") return false;
  return false;
}

export function isMedClipPageMessage(event, data) {
  if (!event || event.source !== window) return false;
  if (!data || data.channel !== "page") return false;
  return isMedClipSourceCompatible(data.source);
}

/** MedClip-authored response/push (rejects legacy Zikaron replies without source). */
export function isAuthoritativeMedClipMessage(data) {
  return data?.source === MEDCLIP_APP_ID;
}

const RECORDING_EVENTS = new Set([
  "recording.state.get",
  "recording.start",
  "recording.stop",
  "recording.cancel",
  "recording.stopped",
  "recording.complete",
  "recording.failed",
  "recording.canceled",
  "record.introductory.video",
]);

export function isMedClipRecordingEvent(eventName) {
  return RECORDING_EVENTS.has(eventName);
}
